import { FC } from 'react';

import { DataSourceType } from '@/models/dataSource';
import { twMerge } from 'tailwind-merge';
import { DataSourceItem } from './DataSourceItem';

type DataSourcesGridProps = {
  dataSources: DataSourceType[];
  className?: string;
};

export const DataSourcesGrid: FC<DataSourcesGridProps> = ({ dataSources, className }) => {
  return (
    <div className={twMerge(`grid grid-cols-[repeat(auto-fit,300px)] gap-4 justify-start max-w-[calc(3.5*300px)]`, className)}>
      {dataSources.map((source) => (
        <DataSourceItem key={source.name} dataSource={source} />
      ))}
    </div>
  );
};
